<dx-popup
  title="Détail de la commande"
  [showTitle]="true"
  [height]="'auto'"
  [width]="500"
  [visible]="visible()"
  (onHiding)="close()"
  [showCloseButton]="true">
  @if (isLoading()) {
    <div>Chargement...</div>
  } @else if (commande(); as commande) {
    <div class="commande-grid">
      <label>Point de livraison</label>
      <span>{{ commande.plcLibelle }}</span>

      <label>Quantité commandée</label>
      <span>{{ commande.qteCommandee | number:'1.0-4' }}</span>

      <label>Unité de commande</label>
      <span>{{ commande.uniteCommandeLibelle || '-' }}</span>

      <label>Quantité intégrée au plan de production</label>
      <span>{{ commande.qteUt | number:'1.0-4' }}</span>

      <label>Unité technique du plat décliné</label>
      <span>{{ commande.uniteTechniqueLibelle }}</span>
    </div>
  } @else {
    <div>Aucune commande de produit complémentaire ne correspond à cette ligne.</div>
  }
</dx-popup>
